export default "__VITE_ASSET__03234437__"